import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useScrollLock } from '../../hooks/useScrollLock'
import { showNestedModal } from '../../features/modal/modalSlice'
import { handleActiveSelect } from '../../features/layout/layoutSlice'
import styled from 'styled-components'
import Button from '../shared/Button'


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;
    .modal{
        width: 550px;
        max-height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        background-color: white;
        /* padding: 20px 50px; */
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        padding: 30px; 
        border-radius: 20px;
        .content{
            width: 100%;
            gap: 15px;
            .info{
                margin-bottom: 40px;
                p{
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 15px;
                    color: #000;
                    margin-bottom: 10px;
                }
                span{
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 15px;
                    color: #000;
                }
            }
        }
    }
    `


const SurucuDegerlendirmeBilgiModal = () => {
    const dispatch = useDispatch()
    const {userData, selectUserData} = useSelector(state => state.user)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {theme} = useSelector((state)=>state.layout)
    const [comment, setComment] = useState("")

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    useEffect(()=>{
        if(selectUserData.truckerUserRate.$values[0].isApproved === 1 ){
            setComment("Onaylanmış yorumunuz var, tekrar yorum yapamazsınız.")
        }
        else if(selectUserData.truckerUserRate.$values[0].isApproved === 2){
            setComment("Reddedilmiş yorumunuz var, tekrar yorum yapamazsınız.")
        }
        else if(selectUserData.truckerUserRate.$values[0].isApproved === 0){
            setComment("Onay bekleyen yorumunuz var tekrar yorum yapamazsınız.")
        }
    },[])

  return (
    <ModalContainer theme={theme} onClick={()=> dispatch(showNestedModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}> 
            <div className="content">
                <div className='info'>
                    <p>{comment}</p>
                    <span>Yorumunuz: {selectUserData.truckerUserRate.$values[0].comment}</span>
                </div>
                <Button handleClick={()=> dispatch(showNestedModal(null))} width={"50%"} background={"#E85446"} text={"Kapat"} color={"white"} padding={"10px"} />
            </div>
        </div>
    </ModalContainer>
  )
}

export default SurucuDegerlendirmeBilgiModal